<div class="contenedor-detalle-apartamento" [ngSwitch]="actual">
    <app-grupo-botones
      [seleccionado]="actual"
      [botones]="opciones"
      (funcionEvent)="handleOpcion($event)"
    ></app-grupo-botones>

    <form class="formulario-titular" *ngSwitchCase="opciones[0]" [formGroup]="titularForm">
      <div class="formulario-titular-grilla">
        <span *ngIf="nombreTitular">Nombre residente</span><input formControlName="nombreTitular" type="text" *ngIf="nombreTitular" readonly>
        <span *ngIf="tipoDocumento">Tipo de documento</span><input formControlName="tipoDocumento" type="text" *ngIf="tipoDocumento" readonly>
        <span *ngIf="documento">Documento</span><input *ngIf="documento" formControlName="documento" type="text" readonly>
        <span>Indicativo</span>
        <div class="fila-indicador">
          <input *ngIf="titularAsignado" type="text" formControlName="indicativo" [readonly]="titularAsignado">
          <app-select-indicativo *ngIf="!titularAsignado"  [indicativoForm]="titularForm" [nombreCampo]="'indicativo'"></app-select-indicativo>
          <div class="campo-celular">
            <span>Celular</span>
            <input type="number" formControlName="celular" [readonly]="titularAsignado">
          </div>
        </div>
      </div>
      <div class="botones-formulario">
        <button (click)="titularAsignado ? eliminarTitular() : agregarTitular()" class="boton-primario">{{titularAsignado ? "Eliminar titular" : "Agregar titular"}}</button>
      </div>  
    </form>

    <app-grupo-familiar *ngSwitchCase="opciones[1]" [grupoFamiliar]="grupoFamiliar" (onCambiarInvitadosPermitidos)="cambiarInvitadosPermitidos($event)"></app-grupo-familiar>

    <form class="formulario-inmueble" *ngSwitchCase="opciones[2]" [formGroup]="inmuebleForm">
      <div class="formulario-inmueble-grilla">
        <span>Área</span><input type="text" formControlName="area" readonly>
        <span>Apartamento/Casa</span><input type="number" formControlName="apartamento" readonly>
        <span>Precio administración</span><input type="number" formControlName="costoAdministracion">
        <span>Estado</span>
        <div class="botones-estado">
          <button [class.boton-primario]="estado === 1" (click)="cambiarEstado(1)">Activo</button>
          <button [class.boton-primario]="estado === 0" (click)="cambiarEstado(0)">Inactivo</button>
        </div>
      </div>
      <app-botones-cambios [mostrar]="inmuebleForm.dirty" (onCancelar)="inmuebleForm.reset(inmuebleFormInitialValues)" (onGuardar)="actualizarInformacionInmueble()" style="margin-left: auto;"></app-botones-cambios>
    </form>
</div>
  